// extracted by mini-css-extract-plugin
module.exports = {"citrusSplash":"#ffc600","youngNight":"#232323"};